import { IoMdClose } from "react-icons/io";
import nodeinstance from "../../../../../../../../nodeInstance";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../../../../store/userSlice";
import { getProjectData } from "../../../../../../../../store/Api";
import { fetchCandidateList } from "../../candidateListFunctions";
import { useNavigate, useParams } from "react-router-dom";
import { CgSpinner } from "react-icons/cg";

export default function VisareturnfromprojectPopUp({
  popUpOpen,
  setPopUpOpen,
  propData,
  updateData,
}) {
  const { projectId } = useParams();

  console.log("propData......propData", projectId);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const token = localStorage.getItem("nodeToken");
  const Laraveltoken = localStorage.getItem("token");
  const [loading, setLoading] = useState(true);
  const [candidateListData, setCandidateListData] = useState();
  const onSubmit = async () => {
    console.log("respoomse.........................");
    if (reverseCount <= 0) {
      dispatch(
        setAppError({
          msg: "Visa count must be a positive integer.",
        })
      );
      return;
    }
    if (reverseCount > propData?.balance) {
      dispatch(
        setAppError({
          msg: "Visa count is greater then balance count.",
        })
      );
      return;
    }
    try {
      const reqObject = {
        count: parseInt(reverseCount),
        project_id: propData.project_id,
      };
      const response = await nodeinstance.put(
        `/dashboard/vrr-visa/visareturnfromstock/${propData.vrf_visa_id}`,
        reqObject,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log("sssssssssss....s.s..s..s.", response);
      if (response.status === 200) {
        setPopUpOpen(false);
        dispatch(getProjectData(Laraveltoken));
        // fetchCandidateList({setLoading,dispatch})
        // fetchCandidateList(projectId, setCandidateListData, setLoading, dispatch);
        dispatch(
          setAppError({
            msg: "Updated successfully.",
            color: "success",
          })
        );
        navigate(`/dashboard/project/${projectId}/job-order`);
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
    // window.location.reload();
  };
  const [reverseCount, setReverseCount] = useState();
  const handleVisareversecount = (event) => {
    setReverseCount(event.target.value);
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          popUpOpen ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUpOpen(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <div className="w-full flex flex-col gap-3 my-3 p-3">
            <div className="flex flex-col p-2 gap-1 w-full max-w-md border-3">
              <p
                className="text-gray-700 font-semibold"
                style={{ fontSize: "15px" }}
              >
                VISA BLOCK NUMBER : {propData?.vrf_visa?.visa_block_number}
              </p>
              <label htmlFor={`addOrEdit-name`} className="text-xs mt-2 ">
                ENTER REVERSE COUNT
              </label>
              <input
                type="number"
                value={reverseCount}
                className="border border-red-500 dark:border-dark rounded-md p-1 py-2"
                onChange={handleVisareversecount}
              />
              <h5 className="text-x4">BALANCE COUNT : {propData?.balance}</h5>
            </div>
            <div className="flex gap-3 w-full justify-center" style={{ m: 2 }}>
              <button
                className="p-2 text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center bg-blue"
                onClick={() => {
                  setPopUpOpen(false);
                }}
              >
                {" "}
                <p>Cancel</p>
              </button>
              <button
                className="p-2 bg-red text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
                onClick={() => {
                  onSubmit();
                }}
              >
                {" "}
                <p>Submit</p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
